import { render, staticRenderFns } from "./journal-edit.vue?vue&type=template&id=231199ac&scoped=true&"
import script from "./journal-edit.vue?vue&type=script&lang=js&"
export * from "./journal-edit.vue?vue&type=script&lang=js&"
import style0 from "./journal-edit.vue?vue&type=style&index=0&id=231199ac&lang=less&scoped=true&"
import style1 from "@/assets/less/i-switch.less?vue&type=style&index=1&id=231199ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231199ac",
  null
  
)

component.options.__file = "journal-edit.vue"
export default component.exports